import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";
import qs from "qs";
import isPlainObject from "lodash/isPlainObject";
import store from "@/store/index";
const http = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://huodong.yaoxiaotong.cn/"
      : "/",
  timeout: 18000,
  withCredentials: true,
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = Cookies.get("language") || "zh-CN";
    config.headers["tenantCode"] = Cookies.get("tenantCode") || "";
    config.headers["tenantCode"] = Cookies.get("tenantCode") || "";
    config.headers["Content-Type"] = "application/json";
    // config.data = true
    //白名单接口
    let arr = [
      "api/Account",
      "api/LearningMaterials/GetLearningMaterialList",
      "api/IndustryExpert/GetIndustryExpertList",
      "api/LearningMaterials/GetRelaLearningMaterials",
      "api/MeetingSignature/addapply",
    ];
    if (arr.indexOf(config.url) == -1) {
      config.headers["Authorization"] = "Bearer " + sessionStorage.getItem('token');
    } else {
    }

    // 默认参数
    var defaults = {};
    // 防止缓存，GET请求默认带_t参数
    if (config.method === "get") {
      config.params = {
        ...config.params,
        ...{ _t: new Date().getTime() },
      };
    }
    if (isPlainObject(config.params)) {
      config.params = {
        ...defaults,
        ...config.params,
      };
    }
    if (isPlainObject(config.data)) {
      config.data = {
        ...defaults,
        ...config.data,
      };
      if (
        /^application\/x-www-form-urlencoded/.test(
          config.headers["content-type"]
        )
      ) {
        config.data = qs.stringify(config.data);
      }
    }
    // get序列化
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  (response) => {
    if (response.data.code === 401 || response.data.code === 10001) {
      handleUnauthorized(response.data.msg);
      return Promise.reject(response.data.msg);
    }
    return response;
  },
  (error) => {
    console.error(error);
    if (error && error.response && error.response.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

// 统一处理 401：清登录态 + 跳登录页
function handleUnauthorized(msg) {
  if (router.currentRoute.path === "/login") return;
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("isToken");
  Cookies.remove("Token");
  if (msg) {
    console.warn("[401]", msg);
  }
  router.replace({ path: "/login" });
}

export default http;
